export default __webpack_public_path__ + "static/media/facebook.a32b5438.svg";